<template lang="pug">
  v-form(ref="bank-details" lazy-validation): v-row.px-5
    v-col.hint-label.pt-0.my-3(cols="12")
      | Ihre Bankverbindung nutzen wir nur, sofern Ihr Antrag positiv entschieden wird!<br>
      | GVL-Mitglieder möchten bitte nach Möglichkeit die bereits bei uns hinterlegte IBAN angeben.

    v-col(cols="6")
      label.primary--text 16. Vorname Name (wie bei Überweisungen angegeben)

      p.text-preview(v-if="readonly") {{ formData.bank_vorname_name }}
      v-text-field(
        v-else
        v-model="formData.bank_vorname_name"
        autocomplete="off"
        outlined
        dense
        :rules="[ rules.required ]"
        @input="(v) => saveFieldValue('bank_vorname_name', v)"
      )

    v-col(cols="6")
      label.primary--text 17. IBAN

      p.text-preview(v-if="readonly") {{ formData.bank_iban }}
      v-text-field.upper-text(
        v-else
        v-model="formData.bank_iban"
        autocomplete="off"
        outlined
        dense
        :rules="[ rules.required, rules.valid_iban ]"
        @input="(v) => saveFieldValue('bank_iban', v)"
      )

    v-col(cols="6")
      label.primary--text 18. BIC

      p.text-preview(v-if="readonly") {{ formData.bank_bic }}
      v-text-field.upper-text(
        v-else
        v-model="formData.bank_bic"
        autocomplete="off"
        outlined
        dense
        :rules="[ rules.required, rules.valid_regexp(/[A-Z0-9]+/i), rules.valid_bic ]"
        @input="(v) => saveFieldValue('bank_bic', v)"
      )

</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator'

import FormMixin from '@/mixins/form'

@Component({
  mixins: [
    FormMixin
  ],
})
export default class BankDetails extends Vue {
  @Prop({ type: Boolean, default: false }) readonly

  get firstErrorField () {
    return this.getFirstErrorField('bank-details')
  }

  mounted () {
    /* global __BUILD_CONFIG__ */
    if (!this.readonly && __BUILD_CONFIG__ === 'development') {
      this.saveFieldValue('bank_iban', 'DE89 3704 0044 0532 0130 00')
      this.saveFieldValue('bank_bic', 'AACSDE33')
    }
  }

  onInputIBAN (v) {
    this.$nextTick(() => {
      v = v.replace(/[-\s]/g, '').toUpperCase().substring(0, 22)
      v = v.match(/.{1,4}/g).join(' ')
      this.saveFieldValue('bank_iban', v)
    })
  }
}
</script>

<style lang="sass">
.upper-text input
  text-transform: uppercase
</style>
